// extracted by mini-css-extract-plugin
export default {"commonCatalog__container":"styles_common-catalog__container__Dw4vY"};